import React from 'react';

interface CustomInputProps {
    id: string;
    label: string;
    placeholder?: string;
    value: string;
    onChange: (value: string) => void;
    error?: boolean;
    disabled?: boolean;
    type?: string;
    className?: string;
}

const CustomInput: React.FC<CustomInputProps> = ({
    id,
    label,
    placeholder,
    value,
    onChange,
    error = false,
    disabled = false,
    type = 'text',
    className = '',
}) => {
    return (
        <div className={`form-group ${error ? 'has-error' : ''} ${className}`}>
            {label && <label htmlFor={id}>{label}</label>}
            <input
                id={id}
                type={type}
                className={`form-control ${error ? 'has-error' : ''}`}
                placeholder={placeholder}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                disabled={disabled}
            />
        </div>
    );
};

export default CustomInput; 